import React, { useMemo } from 'react'
import GenericDetails from '../GenericDetails'

const CharityBusinessPanel = (props) => {
  const { config = {}, record = {} } = props
  
  const alteredConfig = useMemo(() => {
    if (!config.FieldSettings) return config
    return {
      ...config,
      FieldSettings: {
        ...config.FieldSettings['Business'].Fields,
      },
    }
  }, [config])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <GenericDetails activeTabId={2} record={record.Business} config={alteredConfig} />
    </div>
  )
}

export default CharityBusinessPanel
